const strings = {

    TITLE                                   : "CNSI",
    LANGUAGES                               : { "es" : "Español", "en" : "English" },

};

export default strings;
